export const useBlogCategories = () => {
	const get = () => {
		return useAsyncData('blog-categories', async () =>
			await queryCollection('blog')
				.where('stem', 'LIKE', 'blog/%/index')
				.where('stem', 'NOT LIKE', 'blog/%/%/index')
				.all() ?? [],
		);
	};

	return {
		get,
	};
};
